import { useTheme } from '../../hooks/useTheme';

function ThemeToggle({
  id = 'theme-checkbox',
  label = 'Тема',
  className = 'nav-text theme-btn',
}) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <label className={className} htmlFor={id}>
      <i className="fa-solid fa-circle-half-stroke" aria-hidden="true" />
      <strong>{label}</strong>
      <span className="theme-switch">
        <input
          id={id}
          type="checkbox"
          checked={isDark}
          onChange={toggleTheme}
          aria-label="Перемкнути темну тему"
        />
        <span className="slider" aria-hidden="true" />
      </span>
    </label>
  );
}

export default ThemeToggle;
